/* VanillaGoods Baking Tools: plan & budget (4 tools). Needs vgt-core.js.
   Recipe cost: prices from the VanillaGoods Consumer Pricing Guide public feed (National Grocery Chain typical shelf
   price, latest month, U.S.) and, separately, the U.S. Bureau of Labor Statistics average price where the feed carries
   one. The two are never added together. No price -> "not priced yet". Cup weights are the same as the Cups to Grams
   Converter (D.ING in vgt-core.js). Prices load in the browser into VGT.PRICES; compute() only reads it.
   Bake sale pricing, party planner and timeline are arithmetic and our own starting points. */
(function (VGT) {
  'use strict';
  var U = VGT.U, D = VGT.D, ML = U.ML, G = U.G;
  var root = typeof window !== 'undefined' ? window : null;

  /* ================================================ recipe cost ===== */
  // pricing-feed id -> [name, cup-weight key in D.ING, grams per piece]
  var INGS = {
    'all-purpose-flour': ['All-purpose flour', 'ap-flour'], 'bread-flour': ['Bread flour', 'bread-flour'], 'cake-flour': ['Cake flour', 'cake-flour'],
    'almond-flour': ['Almond flour', 'almond-flour'], 'gluten-free-flour-blend': ['Gluten-free flour blend', 'gf-flour'],
    'white-granulated-sugar': ['Granulated sugar', 'sugar'], 'light-brown-sugar': ['Brown sugar', 'brown-sugar'], 'powdered-sugar': ['Powdered sugar', 'powdered-sugar'],
    'honey': ['Honey', 'honey'], 'maple-syrup': ['Maple syrup', 'maple-syrup'], 'corn-syrup': ['Corn syrup', 'corn-syrup'],
    'unsalted-butter': ['Unsalted butter', 'butter', 113], 'vegetable-oil': ['Vegetable oil', 'oil'], 'canola-oil': ['Canola oil', 'oil'], 'coconut-oil': ['Coconut oil', 'coconut-oil'],
    'grade-a-large-eggs': ['Large eggs', 'egg', 50], 'whole-milk': ['Whole milk', 'milk'], '2-milk': ['2% milk', 'milk'], 'buttermilk': ['Buttermilk', 'buttermilk'],
    'heavy-cream': ['Heavy cream', 'heavy-cream'], 'sour-cream': ['Sour cream', 'sour-cream'], 'cream-cheese': ['Cream cheese', 'cream-cheese', 227],
    'evaporated-milk': ['Evaporated milk', 'evap-milk'], 'baking-powder': ['Baking powder', 'baking-powder'], 'baking-soda': ['Baking soda', 'baking-soda'],
    'fine-sea-salt': ['Fine salt', 'salt'], 'kosher-salt': ['Kosher salt', 'kosher-morton'], 'cream-of-tartar': ['Cream of tartar', 'cream-tartar'],
    'active-dry-yeast': ['Active dry yeast', 'active-yeast', 7], 'pure-vanilla-extract': ['Pure vanilla extract', 'vanilla-extract'],
    'natural-cocoa-powder': ['Cocoa powder', 'cocoa'], 'dark-chocolate-chips': ['Dark chocolate chips', 'choc-chips'], 'milk-chocolate-chips': ['Milk chocolate chips', 'choc-chips'],
    'pecans': ['Pecans', 'pecans'], 'blueberries': ['Blueberries', 'blueberries'], 'strawberries': ['Strawberries', 'strawberries'], 'raspberries': ['Raspberries', 'raspberries'],
    'ground-cinnamon': ['Ground cinnamon', 'cinnamon'], 'ground-nutmeg': ['Ground nutmeg', 'nutmeg']
  };
  VGT.COST_INGS = INGS;
  VGT.PRICES = VGT.PRICES || {};   // id -> { chain: {price, unit, period}, bls: {price, unit, period, label} }
  var UNITS = [['cup', 'cups'], ['tbsp', 'tbsp'], ['tsp', 'tsp'], ['g', 'g'], ['oz', 'oz (weight)'], ['lb', 'lb'], ['ml', 'mL'], ['each', 'pieces']];
  var VOL_P = { gal: ML.gallon, qt: ML.quart, 'fl oz': ML.floz, pint: ML.pint, l: 1000, ml: 1 };
  var MASS_P = { lb: G.lb, oz: G.oz, kg: 1000, g: 1 };
  /** How many price units a recipe line is, or null when it can't be converted. */
  function priceQty(id, amt, unit, pu) {
    var I = INGS[id] || [id, ''], d = I[1] ? D.density(I[1]) : 0, each = I[2] || 0, g = null, ml = null, n = null;
    if (unit === 'each') { n = amt; if (each) g = amt * each; }
    else if (ML[unit]) { ml = amt * ML[unit]; if (d) g = ml * d; }
    else if (G[unit]) g = amt * G[unit];
    if (g != null && ml == null && d) ml = g / d;
    if (n == null && each && g != null) n = g / each;
    if (MASS_P[pu]) return g == null ? null : g / MASS_P[pu];
    if (VOL_P[pu]) return ml == null ? null : ml / VOL_P[pu];
    if (pu === 'dozen') return n == null ? null : n / 12;
    if (pu === 'each') return n;
    return null;
  }
  VGT.priceQty = priceQty;
  var UW = { cup: ['cup', 'cups'], tbsp: ['tbsp', 'tbsp'], tsp: ['tsp', 'tsp'], g: ['g', 'g'], oz: ['oz', 'oz'], lb: ['lb', 'lb'], ml: ['mL', 'mL'] };
  function lineTxt(a, u, name) {
    if (u === 'each') return U.fmt(a, 2) + ' \u00d7 ' + name.toLowerCase();
    var w = UW[u] || [u, u];
    return U.fmt(a, 2) + ' ' + (Math.abs(a - 1) < 1e-9 || a < 1 ? w[0] : w[1]) + ' ' + name.toLowerCase();
  }
  function money(x) { return '$' + (Math.round(x * 100) / 100).toFixed(2); }
  function ingOptions() {
    var ids = Object.keys(INGS);
    Object.keys(VGT.PRICES).forEach(function (k) { if (ids.indexOf(k) < 0 && VGT.PRICES[k].name) ids.push(k); });
    return ids.map(function (k) { return [k, (INGS[k] || [VGT.PRICES[k].name])[0]]; }).sort(function (a, b) { return a[1] < b[1] ? -1 : 1; });
  }
  VGT.tool('recipe-cost-calculator', {
    name: 'Recipe Cost Calculator',
    fields: [
      { id: 'rows', type: 'rows', label: 'Ingredients', min: 1, max: 30, add: 'Add an ingredient',
        fields: [{ id: 'i', type: 'sel', label: 'Ingredient', w: 'name', options: ingOptions }, { id: 'a', type: 'num', label: 'Amount' },
          { id: 'u', type: 'sel', label: 'Unit', options: UNITS }, { id: 'p', type: 'num', label: 'Your price', suffix: '$' }],
        value: [{ i: 'all-purpose-flour', a: '2', u: 'cup', p: '' }, { i: 'white-granulated-sugar', a: '1', u: 'cup', p: '' }, { i: 'unsalted-butter', a: '1', u: 'each', p: '' },
          { i: 'grade-a-large-eggs', a: '2', u: 'each', p: '' }, { i: 'pure-vanilla-extract', a: '2', u: 'tsp', p: '' }, { i: 'whole-milk', a: '0.5', u: 'cup', p: '' }],
        newRow: { i: 'baking-powder', u: 'tsp' } },
      { id: 'serv', type: 'num', label: 'Servings', value: '12', min: 1, max: 1000 }
    ],
    compute: function (v) {
      var rows = [], tC = 0, tB = 0, tM = 0, nC = 0, nB = 0, unpriced = [], any = Object.keys(VGT.PRICES).length > 0;
      v.rows.forEach(function (r) {
        if (!isFinite(r.a) || r.a <= 0) return;
        var P = VGT.PRICES[r.i] || {}, name = (INGS[r.i] || [P.name || r.i])[0], cells = [lineTxt(r.a, r.u, name)];
        var one = function (src) {
          if (!src) return { t: 'not priced yet', cls: 'is-muted' };
          var q = priceQty(r.i, r.a, r.u, src.unit);
          if (q == null) return { t: 'can\u2019t convert ' + r.u, cls: 'is-muted' };
          return { t: money(q * src.price), v: q * src.price };
        };
        var c = one(P.chain), b = one(P.bls), m = null;
        if (isFinite(r.p) && P.chain) { var qm = priceQty(r.i, r.a, r.u, P.chain.unit); if (qm != null) { m = qm * r.p; tM += m; } }
        if (c.v != null) { tC += c.v; nC++; } else if (!P.chain) unpriced.push(name);
        if (b.v != null) { tB += b.v; nB++; }
        rows.push(cells.concat([c, b, m == null ? '\u2013' : money(m)]));
      });
      if (!rows.length) return { error: 'Add at least one ingredient with an amount.' };
      var cards = [
        { label: 'National Grocery Chain prices', value: nC ? money(tC) : 'Not priced yet', sub: nC ? money(tC / v.serv) + ' a serving; ' + nC + ' of ' + rows.length + ' lines priced' : (any ? 'none of these lines have a price yet' : 'prices load from our pricing guide') },
        { label: 'BLS average prices', value: nB ? money(tB) : '\u2013', sub: nB ? nB + ' of ' + rows.length + ' lines have a BLS price' : 'BLS publishes average prices for only a few baking staples' }];
      if (tM) cards.push({ label: 'With your prices', value: money(tM), sub: 'lines where you typed a price (per the chain\u2019s unit)' });
      return {
        cards: cards,
        tables: [{ title: 'Line by line', head: ['Ingredient', 'National Grocery Chain', 'BLS average', 'Your price'], rows: rows,
          note: 'The two price sources are shown side by side and never added together. Cup weights are the same as our Cups to Grams Converter.' }],
        notes: [unpriced.length ? 'Not priced yet: ' + unpriced.join(', ') + '. Type what you paid in Your price.' : '',
          'National Grocery Chain prices are the typical shelf price across the stores in our pricing sample, for the latest month. BLS prices are U.S. city averages. Your own store may differ; type your price to override.'].filter(Boolean),
        links: [{ href: '/pages/consumer-pricing-guide', text: 'Consumer Pricing Guide' }, { href: '/pages/bake-sale-pricing-calculator', text: 'Price your bakes to sell' }, { href: '/pages/recipe-scaling-calculator', text: 'Scale the recipe' }]
      };
    }
  });

  /* Load prices in the browser: the pricing summary (chain, national) plus each item's file for BLS. */
  if (root && root.document) {
    var started = false;
    var load = function () {
      if (started) return;
      var el = document.querySelector('[data-vgt-tool="recipe-cost-calculator"]');
      var url = el && el.getAttribute('data-pricing');
      if (!url) return;
      started = true;
      fetch(url, { credentials: 'omit' }).then(function (r) { return r.json(); }).then(function (d) {
        var names = {};
        (d.catalog || []).forEach(function (c) { names[c.id] = c; });
        (d.observations || []).forEach(function (o) {
          if (o.geography_type !== 'national' || o.tier !== 'retail' || !(o.price > 0)) return;
          var cur = VGT.PRICES[o.ingredient_id] = VGT.PRICES[o.ingredient_id] || { name: (names[o.ingredient_id] || {}).name };
          if (!cur.chain || o.period > cur.chain.period) cur.chain = { price: o.price, unit: o.unit, period: o.period };
        });
        var base = url.replace(/[^/]*$/, ''), files = d.ingredient_files || {};
        var blsIds = (d.catalog || []).filter(function (c) { return c.bls_series && files[c.id]; }).map(function (c) { return c.id; });
        var redraw = function () { (VGT.instances || []).forEach(function (t) { if (t.spec.key === 'recipe-cost-calculator') t.update(true); }); };
        redraw();
        Promise.all(blsIds.map(function (id) {
          return fetch(base + 'vgp-i-' + id + '.json?v=' + files[id], { credentials: 'omit' }).then(function (r) { return r.json(); }).then(function (f) {
            var last = null;
            (f.reference_series || []).forEach(function (o) { if (o.price > 0 && (!last || o.period > last.period)) last = o; });
            if (last) { var cur = VGT.PRICES[id] = VGT.PRICES[id] || { name: (names[id] || {}).name }; cur.bls = { price: last.price, unit: last.unit, period: last.period, label: last.series_label }; }
          }).catch(function () { /* that item just has no BLS price */ });
        })).then(redraw);
      }).catch(function () { /* the page still works with typed prices */ });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', load); else load();
  }

  /* ================================================ bake sale & home bakery pricing ===== */
  VGT.tool('bake-sale-pricing-calculator', {
    name: 'Bake Sale & Home Bakery Pricing',
    units: false,
    fields: [
      { id: 'ing', type: 'num', label: 'Ingredients for the batch', value: '12', min: 0, max: 100000, suffix: '$' },
      { id: 'n', type: 'num', label: 'Items in the batch', value: '24', min: 1, max: 100000 },
      { id: 'pack', type: 'num', label: 'Packaging per item', value: '0.10', min: 0, max: 1000, suffix: '$' },
      { id: 'hrs', type: 'num', label: 'Your time', value: '1.5', min: 0, max: 1000, suffix: 'hours' },
      { id: 'pay', type: 'num', label: 'Pay yourself', value: '15', min: 0, max: 1000, suffix: '$/hour' },
      { id: 'ovh', type: 'num', label: 'Overhead (power, gas, wear)', value: '0', min: 0, max: 200, suffix: '%' },
      { id: 'mg', type: 'num', label: 'Profit margin', value: '0', min: 0, max: 90, suffix: '%' }
    ],
    compute: function (v) {
      var batch = (v.ing + v.hrs * v.pay) * (1 + v.ovh / 100), cost = batch / v.n + v.pack, price = cost / (1 - v.mg / 100);
      return {
        cards: [{ label: 'Price per item', value: money(price), sub: v.mg ? U.fmt(v.mg, 1) + '% margin on ' + money(cost) + ' cost' : 'covers costs and your time; no profit' },
          { label: 'Per dozen', value: money(price * 12), sub: 'the whole batch: ' + money(price * v.n) },
          { label: 'Cost per item', value: money(cost), sub: money(v.ing / v.n) + ' ingredients, ' + money(v.hrs * v.pay / v.n) + ' time, ' + money(v.pack) + ' packaging' }],
        notes: ['Margin is profit as a share of the price: price = cost \u00f7 (1 \u2212 margin). These are your numbers; the tool doesn\u2019t suggest a market price.',
          'Selling from home? Check your state\u2019s cottage food rules for what you can sell, labeling and where.'],
        links: [{ href: '/pages/recipe-cost-calculator', text: 'What the ingredients cost' }, { href: '/pages/consumer-pricing-guide', text: 'Consumer Pricing Guide' }]
      };
    }
  });

  /* ================================================ party dessert planner ===== */
  // per serving: pies 8 slices, cookies 2 per serving, cupcakes 1, 9x13 sheet cake 24, bars 1 (our starting point)
  var DESS = [['pies', 'Pies (9 in)', 8, 'pie', 'pies'], ['cookies', 'Cookies', 0.5, 'cookie', 'cookies'], ['cupcakes', 'Cupcakes', 1, 'cupcake', 'cupcakes'],
    ['sheet', '9\u00d713 sheet cakes', 24, 'sheet cake', 'sheet cakes'], ['bars', 'Brownies or bars', 1, 'bar', 'bars']];
  VGT.tool('party-dessert-planner', {
    name: 'Party Dessert Planner',
    units: false,
    fields: [
      { id: 'g', type: 'num', label: 'Guests', value: '24', min: 1, max: 5000, quick: [['12', '12'], ['24', '24'], ['50', '50']] },
      { id: 'ap', type: 'seg', label: 'Appetite', value: '1.5', options: [['1', 'Light (1 serving each)'], ['1.5', 'Average (1\u00bd)'], ['2', 'Big (2)']] },
      { id: 'pies', type: 'chk', label: 'Pies', value: true }, { id: 'cookies', type: 'chk', label: 'Cookies', value: false },
      { id: 'cupcakes', type: 'chk', label: 'Cupcakes', value: false }, { id: 'sheet', type: 'chk', label: '9\u00d713 sheet cake', value: false },
      { id: 'bars', type: 'chk', label: 'Brownies or bars', value: false }
    ],
    compute: function (v) {
      var on = DESS.filter(function (d) { return v[d[0]]; });
      if (!on.length) return { error: 'Tick at least one dessert.' };
      var serv = Math.ceil(v.g * +v.ap), share = serv / on.length;
      var cards = on.map(function (d) {
        var n = d[2] >= 1 ? Math.ceil(share / d[2] - 1e-9) : Math.ceil(share / d[2] - 1e-9);
        return { label: d[1], value: n + ' ' + U.plural(n, d[3], d[4]), sub: d[2] >= 1 ? (d[2] > 1 ? n * d[2] + ' servings' : n + ' servings') : n / 2 + ' servings (2 cookies each)' };
      });
      cards.unshift({ label: 'Servings', value: serv + '', sub: v.g + ' guests \u00d7 ' + v.ap });
      return {
        cards: cards, flat: false,
        notes: ['These are our starting points: a 9-inch pie cuts into 8 slices, a 9\u00d713 sheet cake into 24 pieces, and 2 cookies make a serving. Plan a little extra if dessert is the main event.'],
        links: [{ href: '/pages/cake-serving-calculator', text: 'Cake servings by pan' }, { href: '/pages/cookie-scoop-calculator', text: 'How many cookies a batch makes' }, { href: '/pages/recipe-scaling-calculator', text: 'Scale a recipe' }, { href: '/pages/bake-day-timeline-planner', text: 'Plan the bake day' }]
      };
    }
  });

  /* ================================================ bake-day timeline ===== */
  var KINDS = [['mix', 'Mix'], ['chill', 'Chill'], ['proof', 'Rise / proof'], ['bake', 'Bake'], ['cool', 'Cool'], ['frost', 'Frost / finish'], ['other', 'Other']];
  var TIMES = []; for (var m = 0; m < 1440; m += 15) TIMES.push([String(m), clock(m)]);
  function clock(min) { var t = ((min % 1440) + 1440) % 1440, h = Math.floor(t / 60), mm = t % 60; return (h % 12 || 12) + ':' + (mm < 10 ? '0' : '') + mm + ' ' + (h < 12 ? 'AM' : 'PM'); }
  VGT.clock = clock;
  function dayTxt(min) { return min < 0 ? (min < -1440 ? ' (2 days before)' : ' (the day before)') : ''; }
  VGT.tool('bake-day-timeline-planner', {
    name: 'Bake-Day Timeline Planner',
    units: false,
    fields: [
      { id: 'serve', type: 'sel', label: 'Serve at', value: '1080', options: TIMES },
      { id: 'steps', type: 'rows', label: 'Steps, in order', min: 1, max: 20, add: 'Add a step',
        fields: [{ id: 'k', type: 'sel', label: 'Step', options: KINDS }, { id: 'm', type: 'num', label: 'Minutes', suffix: 'min' }],
        value: [{ k: 'mix', m: '20' }, { k: 'bake', m: '35' }, { k: 'cool', m: '60' }, { k: 'frost', m: '20' }], newRow: { k: 'other', m: '15' } },
      { id: 'pre', type: 'num', label: 'Oven preheat', value: '15', min: 0, max: 60, suffix: 'min' }
    ],
    compute: function (v) {
      var steps = v.steps.filter(function (s) { return isFinite(s.m) && s.m > 0; });
      if (!steps.length) return { error: 'Add at least one step with minutes.' };
      var serve = +v.serve, total = steps.reduce(function (a, s) { return a + s.m; }, 0), t = serve - total, items = [], pre = null;
      steps.forEach(function (s) {
        var name = KINDS.filter(function (k) { return k[0] === s.k; })[0][1];
        if (s.k === 'bake' && pre == null && v.pre > 0) pre = t - v.pre;
        items.push({ at: t, d: name + ' (' + U.mins(s.m) + ')' });
        t += s.m;
      });
      if (pre != null) items.push({ at: pre - 0.5, d: 'Preheat the oven' });
      items.sort(function (a, b) { return a.at - b.at; });
      items = items.map(function (it) { var a = Math.round(it.at); return { t: clock(a) + dayTxt(a), d: it.d }; });
      items.push({ t: clock(serve), d: 'Serve' });
      var start = Math.min(serve - total, pre == null ? Infinity : pre);
      return {
        cards: [{ label: 'Start by', value: clock(serve - total) + dayTxt(serve - total), sub: U.mins(total) + ' from start to serving' }]
          .concat(pre != null ? [{ label: 'Preheat at', value: clock(pre) + dayTxt(pre), sub: v.pre + ' min before the bake' }] : []),
        lists: [{ title: 'Your timeline', items: items }],
        notes: [start < 0 ? 'This plan starts the day before; chilled and risen steps often work well overnight.' : 'Add a 15-minute cushion before guests arrive; ovens and doughs run late.'],
        links: [{ href: '/pages/dough-proofing-calculator', text: 'How long dough takes to rise' }, { href: '/pages/baking-time-calculator', text: 'Baking time for a different pan' }]
      };
    }
  });
})((typeof window !== 'undefined' ? window : globalThis).VGT);
